import { clone } from '@jack-henry/frontend-utils/functions';
import { DashboardResourcesModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

const nullResource: DashboardResourcesModelDto = {
    title: '',
    link: '',
    tooltip: '',
    displayExternalWarning: false,
    externalWarningMessage: '',
    sequence: 0,
    logo: '',
};

export class ResourceCenterItem extends DomainEntity<DashboardResourcesModelDto> {
    constructor(dto = clone(nullResource)) {
        super(dto);
    }

    public createDefault(): this {
        return new ResourceCenterItem(clone(nullResource)) as this;
    }

    public get title() {
        return this.dto.title;
    }

    public get link() {
        return this.dto.link;
    }

    public get tooltip() {
        return this.dto.tooltip;
    }

    public get displayExternalWarning() {
        return this.dto.displayExternalWarning;
    }

    public get externalWarningMessage() {
        return this.dto.externalWarningMessage;
    }

    public get sequence() {
        return this.dto.sequence;
    }

    public get logo() {
        return this.dto.logo;
    }
}
